export default __webpack_public_path__ + "images/eth_f16ac1.svg";